module.exports = "/fonts/Ki.ttf?670df2d1373e4135c464502f80a1784c";